/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserAdditionalHistory from './user-additional-history';
import UserAdditionalHistoryDetail from './user-additional-history-detail';
import UserAdditionalHistoryUpdate from './user-additional-history-update';
import UserAdditionalHistoryDeleteDialog from './user-additional-history-delete-dialog';

const UserAdditionalHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserAdditionalHistory />} />
    <Route path="new" element={<UserAdditionalHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<UserAdditionalHistoryDetail />} />
      <Route path="edit" element={<UserAdditionalHistoryUpdate />} />
      <Route path="delete" element={<UserAdditionalHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserAdditionalHistoryRoutes;
